import React from 'react';
import Menu from '../../components/Menu/Menu';
function ComoFunciona() {

      return (
      <React.Fragment>
        <Menu />
        <main className="content">

        <div className="container mt-5">

              
              
              <h3>Como Funciona</h3>
              
              <p> Em construção </p>



        </div>

            
        </main>
      </React.Fragment>
       
      );
};
    

export default ComoFunciona;